    export const environment = {
      production: true,
      loginurl: 'https://srv1218654.hstgr.cloud/web-service-1.0-SNAPSHOT/api/',
      apiurl: 'https://srv1218654.hstgr.cloud/web-service-1.0-SNAPSHOT/api/v1/',
      domain: 'srv1218654.hstgr.cloud',
};
